import { render, staticRenderFns } from "./BMobileCartItem.vue?vue&type=template&id=62704b21&scoped=true"
import script from "./BMobileCartItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./BMobileCartItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BMobileCartItem.vue?vue&type=style&index=0&id=62704b21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62704b21",
  null
  
)

export default component.exports